import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import store from 'general/js/store';
import BaseComponent from 'foundation/base-component';
import QualDrawLayout from './qual-draw-layout.js';

class QualDrawComponent extends BaseComponent {
    constructor(...args) {
        super(...args);
        this.init();
    }

    static getRequiredRefs() {
        return ['root'];
    }

    init() {
        this.render();
    }

    onDestroy() {
        ReactDOM.unmountComponentAtNode(this.refs.root);
    }

    render() {
        ReactDOM.render(
            <Provider store={store}>
                <QualDrawLayout options={this.options} />
            </Provider>,
            this.refs.root
        );
    }
}

export default QualDrawComponent;
